














import { Component, Vue } from 'vue-property-decorator'
import IndoorDisplay from '@/components/indoor/IndoorDisplay.vue'
import IndoorDisplayMobile from '@/components/indoor/IndoorDisplayMobile.vue'
import IndoorNoGmapDisplay from '@/components/indoor/IndoorNoGmapDisplay.vue'

@Component({
  components: {
    IndoorDisplay,
    IndoorDisplayMobile,
    IndoorNoGmapDisplay,
  },

  computed: {},
})
export default class Indoor extends Vue {
  get isCloudMode(): boolean {
    return process.env.VUE_APP_CLOUD_MODE === '1'
  }
}
